var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Misroute Marking Form")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isResetLoad
    },
    on: {
      "update:active": function($event) {
        _vm.isResetLoad = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 tabs-active"
  }, [_c('b-tabs', {
    staticClass: "requestTab",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    class: {
      active: _vm.currentTab == 'Request Misroute'
    },
    attrs: {
      "title": "Request Misroute",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "card-body col-md-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.getShipDataLoader
    },
    on: {
      "update:active": function($event) {
        _vm.getShipDataLoader = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Enter AWB No :")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        IsValidShipment: true
      }),
      expression: "{required: true,IsValidShipment: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.txtShipment),
      expression: "txtShipment"
    }],
    ref: "txtShipment",
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('txtShipment')
    },
    attrs: {
      "id": "txtShipment",
      "type": "text",
      "name": "ShippingId",
      "placeholder": "Enter AWB Number"
    },
    domProps: {
      "value": (_vm.txtShipment)
    },
    on: {
      "change": _vm.getShipmentData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtShipment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ShippingId')),
      expression: "errors.has('form-1.ShippingId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.ShippingId')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.sameVendorShipCount > 0) && _vm.moreShipLink && _vm.txtShipment),
      expression: "(sameVendorShipCount > 0) && moreShipLink && txtShipment"
    }]
  }, [_c('span', {
    staticClass: "moreShipLinkCSS",
    on: {
      "click": function($event) {
        return _vm.showMoreShipmentsList(null)
      }
    }
  }, [_vm._v("and " + _vm._s(_vm.sameVendorShipCount) + " more")]), _vm._v("  \n                                    "), _c('span', {
    staticClass: "sameVendorShipMsgCSS"
  }, [_vm._v(" Shipments found for the same VendorName and VendorAddress. ")])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.txtShipment),
      expression: "txtShipment"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Shipment Type :")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqShipmentType),
      expression: "ReqShipmentType"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "id": "ReqShipmentType",
      "type": "text",
      "name": "ReqShipmentType",
      "placeholder": "Shipment Type"
    },
    domProps: {
      "value": (_vm.ReqShipmentType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqShipmentType = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ReqShipmentType')),
      expression: "errors.has('form-1.ReqShipmentType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Shipment Type. ")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.txtShipment && _vm.isRTODTO),
      expression: "txtShipment && isRTODTO"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Vendor Name :")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqVendorName),
      expression: "ReqVendorName"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "id": "ReqVendorName",
      "type": "text",
      "name": "ReqVendorName",
      "placeholder": "Vendor Name"
    },
    domProps: {
      "value": (_vm.ReqVendorName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqVendorName = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.txtShipment && _vm.isRTODTO),
      expression: "txtShipment && isRTODTO"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Vendor Address :")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ReqVendorAddr),
      expression: "ReqVendorAddr"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "id": "ReqVendorAddr",
      "type": "text",
      "name": "ReqVendorAddr",
      "placeholder": "Vendor Address"
    },
    domProps: {
      "value": (_vm.ReqVendorAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReqVendorAddr = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.txtShipment),
      expression: "txtShipment"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [(!_vm.isRTODTO) ? _c('span', {
    staticClass: "input-group-text shipdetails"
  }, [_vm._v("Current Pincode :")]) : _c('span', {
    staticClass: "input-group-text shipdetails"
  }, [_vm._v("RTO/DTO Pincode :")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.CurrentPincode),
      expression: "CurrentPincode"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "id": "CurrentPincode",
      "type": "text",
      "name": "CurrentPincode",
      "placeholder": "Current Pincode"
    },
    domProps: {
      "value": (_vm.CurrentPincode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CurrentPincode = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.txtShipment),
      expression: "txtShipment"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text shipdetails"
  }, [_vm._v("Current Destination SVC :")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.CurrentDestSVC),
      expression: "CurrentDestSVC"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "id": "CurrentDestSVC",
      "type": "text",
      "name": "CurrentDestSVC",
      "placeholder": "Current SVC"
    },
    domProps: {
      "value": (_vm.CurrentDestSVC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CurrentDestSVC = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Reason For Misroute :")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3",
    attrs: {
      "right": _vm.ReasonLoader
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisrouteReasonList,
      "selected-option": _vm.MisrouteReasonObj,
      "name": "ReqMisrouteReason",
      "placeholder": "--Select Reason--"
    },
    on: {
      "select": _vm.selectMisrouteReason
    },
    model: {
      value: (_vm.ReqMisrouteReason),
      callback: function($$v) {
        _vm.ReqMisrouteReason = $$v
      },
      expression: "ReqMisrouteReason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ReqMisrouteReason')),
      expression: "errors.has('form-1.ReqMisrouteReason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Misroute Reason.")])], 1)]), _vm._v(" "), (!_vm.isRTODTO) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Suggested Pincode :")])]), _vm._v(" "), (!_vm.isGeoPincodesAndHub || !_vm.isGeoFlowEnabled) ? _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtPincode),
      expression: "txtPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.MarkShipmentStatus == 'XBU00260' ? 'required|numeric|max:6|min:6' : 'numeric|max:6|min:6'))),
      expression: "`${MarkShipmentStatus == 'XBU00260' ? 'required|numeric|max:6|min:6' : 'numeric|max:6|min:6'}`"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('txtPincode')
    },
    attrs: {
      "disabled": _vm.IsValidationError == true || !_vm.isCorrectPinInput,
      "id": "txtPincode",
      "type": "text",
      "name": "txtPincode",
      "placeholder": "Enter correct pincode"
    },
    domProps: {
      "value": (_vm.txtPincode)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "change": _vm.gethubagainstAWBandPincode,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtPincode = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isGeoPincodesAndHub && _vm.isGeoFlowEnabled) ? _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.geoPincodeList,
      "selected-option": _vm.geoPincodeObj,
      "name": "ddlHub",
      "placeholder": "--Select Pincode--"
    },
    on: {
      "select": _vm.selectGeoPincode
    },
    model: {
      value: (_vm.geoPincode),
      callback: function($$v) {
        _vm.geoPincode = $$v
      },
      expression: "geoPincode"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.txtPincode')),
      expression: "errors.has('form-1.txtPincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Correct Pincode.")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.hubDiv == true) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.hubFlag == true) ? _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Suggested Destination SVC :")])]) : _vm._e(), _vm._v(" "), ((_vm.txtPincode || _vm.isGeoPincodesAndHub) && !_vm.isRTODTO) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isHubLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isHubLoading = $event
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.hub))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.IsValidationError == false && _vm.isRTODTO && !_vm.txtPincode && !_vm.isGeoPincodesAndHub || (_vm.txtPincode && _vm.isRTODTO)) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.HubLoader
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.HubList,
      "selected-option": _vm.HubObj,
      "name": "ddlHub",
      "placeholder": "--Select hub--"
    },
    on: {
      "select": _vm.selectHub
    },
    model: {
      value: (_vm.ddlHub),
      callback: function($$v) {
        _vm.ddlHub = $$v
      },
      expression: "ddlHub"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ddlHub')),
      expression: "errors.has('form-1.ddlHub')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select DestinationHub.")]), _vm._v(" "), (!_vm.isCorrectPinInput && _vm.hub && !_vm.isRTODTO) ? _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_vm._v(_vm._s('Shipment for the given address was previously delivered from the ' + this.hub + ' facility.'))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v("Save")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": function($event) {
        return _vm.clearMisrouteForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    on: {
      "click": _vm.clearMisrouteForm
    }
  }), _vm._v("Clear")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSubmitLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isSubmitLoading = $event
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.reqBlockMsgByMDM != '') ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.txtShipment) + " :- " + _vm._s(_vm.reqBlockMsgByMDM))]), _c('br')]) : _vm._e(), _vm._v(" "), _c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDown,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged,
      "dismissed": _vm.CloseSuccessErrorResModel
    }
  }, [(_vm.requestsErrorMsg.length > 0) ? _c('div', [_c('span', {
    staticClass: "SuccCount"
  }, [_vm._v("Success Count : " + _vm._s(_vm.reqSuccessCount))])]) : _vm._e(), _vm._v(" "), (_vm.requestsErrorMsg.length > 0) ? _c('div', [_c('span', {
    staticClass: "ErrCount"
  }, [_vm._v("Error Count : " + _vm._s(_vm.reqErrorCount))])]) : _vm._e(), _vm._v(" "), (_vm.requestsErrorMsg.length > 0) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._l((_vm.requestsErrorMsg), function(item) {
    return [_c('span', [_vm._v(_vm._s(item.Shipment) + " :- " + _vm._s(item.message))]), _c('br')]
  })], 2) : _vm._e()])], 1)])])], 1), _vm._v(" "), _c('b-tab', {
    class: {
      active: _vm.currentTab == 'Request Status'
    },
    attrs: {
      "title": "Request Status",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-group row Date-enlarge-css"
  }, [_c('b-form-fieldset', {
    staticClass: "col-md-3 DT-input-css"
  }, [_c('b-input-group', [_c('label', [_vm._v("From:")]), _vm._v("  \n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromdate),
      expression: "fromdate"
    }],
    staticClass: "form-control DateFt-css",
    attrs: {
      "type": "date",
      "lang": "en",
      "name": "fromdate",
      "onkeydown": "return false",
      "not-before": _vm.validDateRangeFrom,
      "not-after": _vm.validDateRangeFrom
    },
    domProps: {
      "value": (_vm.fromdate)
    },
    on: {
      "change": _vm.checkFromDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromdate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('b-form-fieldset', {
    staticClass: "col-md-3 mr-1 DT-input-css",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('b-input-group', [_c('label', [_vm._v("To:")]), _vm._v("  \n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.todate),
      expression: "todate"
    }],
    staticClass: "form-control DateFt-css",
    attrs: {
      "lang": "en",
      "type": "date",
      "min": _vm.selectedFromDate,
      "disabled": !_vm.fromdate,
      "name": "todate",
      "not-before": _vm.todate
    },
    domProps: {
      "value": (_vm.todate)
    },
    on: {
      "change": _vm.checkToDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.todate = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-tabs', {
    staticClass: "requestTab1",
    staticStyle: {
      "margin-top": "-70px",
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex1),
      callback: function($$v) {
        _vm.ActiveTabIndex1 = $$v
      },
      expression: "ActiveTabIndex1"
    }
  }, [_c('b-tab', {
    class: {
      active: _vm.currentTab1 == 'All Requests'
    },
    attrs: {
      "title": _vm.tabTitle('All Requests', _vm.allReqCount),
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.SwitchReqTabs()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "makermoreFilterCSS"
  }, [(_vm.currentFiltersTab != 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'moreFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('moreFilters')
      }
    }
  }, [_vm._v("More Filters\n                              ")])]) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'clearFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('clearFilters')
      }
    }
  }, [_vm._v("Clear Filters\n                              ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4 mt-1"
  }, [_c('label', [_vm._v("Enter ShippingIDs:")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchShip),
      expression: "SearchShip"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('SearchShip')
    },
    attrs: {
      "id": "SearchShip",
      "type": "text",
      "name": "SearchShip",
      "placeholder": "Enter ShippingIDs"
    },
    domProps: {
      "value": (_vm.SearchShip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.SearchShip = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-1"
  }, [_c('label', [_vm._v("Shipment Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ShipmentTypeList,
      "selected-option": _vm.ShipmentTypeObj,
      "name": "ShipmentType",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectShipmentType
    },
    model: {
      value: (_vm.ShipmentType),
      callback: function($$v) {
        _vm.ShipmentType = $$v
      },
      expression: "ShipmentType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-1"
  }, [_c('label', [_vm._v("Misroute Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisroutetypeList,
      "selected-option": _vm.MisroutetypeObj,
      "name": "MisrouteType",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteType
    },
    model: {
      value: (_vm.MisrouteType),
      callback: function($$v) {
        _vm.MisrouteType = $$v
      },
      expression: "MisrouteType"
    }
  })], 1)], 1), _vm._v(" "), (_vm.currentFiltersTab != 'moreFilters') ? _c('div', {
    staticClass: "col-md-2 tabs-btn-css"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.searchByFilters(), _vm.searchByDateFilter()
      }
    }
  }, [_vm._v(" Search ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger ml-2",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4 mt-3"
  }, [_c('label', [_vm._v("Misroute Reason :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisrouteReasonList,
      "selected-option": _vm.MisrouteReasonObj,
      "name": "MisrouteReason",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteReason
    },
    model: {
      value: (_vm.MisrouteReason),
      callback: function($$v) {
        _vm.MisrouteReason = $$v
      },
      expression: "MisrouteReason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 tabs-btn-css1"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.searchByFilters(), _vm.searchByDateFilter()
      }
    }
  }, [_vm._v(" Search ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger ml-2",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 ml-2 mt-3"
  }, [_c('span', {
    staticClass: "totalCount-Css"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))])]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12 tableTemplateCSS"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.AllReqColumns,
      "IsWithDraw": true,
      "Shipmentloader": _vm.Shipmentloader,
      "showShipmentsList": _vm.showShipmentReqList
    },
    on: {
      "showMultiShipPopup": _vm.showMoreShipmentsList,
      "withDrawReq": _vm.withDrawReq
    },
    model: {
      value: (_vm.ShowAllReqModel),
      callback: function($$v) {
        _vm.ShowAllReqModel = $$v
      },
      expression: "ShowAllReqModel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_c('paginate', {
    ref: "AllReqpaginate",
    attrs: {
      "page-count": _vm.AllReqPagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])])], 1), _vm._v(" "), _c('b-tab', {
    class: {
      active: _vm.currentTab1 == 'Pending'
    },
    attrs: {
      "title": _vm.tabTitle('Pending', _vm.pendignShipCount + _vm.unAssTabShipCount),
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.SwitchReqTabs()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "makermoreFilterCSS"
  }, [(_vm.currentFiltersTab != 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'moreFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('moreFilters')
      }
    }
  }, [_vm._v("More Filters\n                              ")])]) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'clearFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('clearFilters')
      }
    }
  }, [_vm._v("Clear Filters\n                              ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4 mt-1"
  }, [_c('label', [_vm._v("Enter ShippingIDs:")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchShip1),
      expression: "SearchShip1"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('SearchShip1')
    },
    attrs: {
      "id": "SearchShip1",
      "type": "text",
      "name": "SearchShip1",
      "placeholder": "Enter ShippingIDs"
    },
    domProps: {
      "value": (_vm.SearchShip1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.SearchShip1 = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-1"
  }, [_c('label', [_vm._v("Shipment Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ShipmentTypeList,
      "selected-option": _vm.ShipmentTypeObj,
      "name": "ShipmentType1",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectShipmentType
    },
    model: {
      value: (_vm.ShipmentType1),
      callback: function($$v) {
        _vm.ShipmentType1 = $$v
      },
      expression: "ShipmentType1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-1"
  }, [_c('label', [_vm._v("Misroute Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisroutetypeList,
      "selected-option": _vm.MisroutetypeObj,
      "name": "MisrouteType1",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteType
    },
    model: {
      value: (_vm.MisrouteType1),
      callback: function($$v) {
        _vm.MisrouteType1 = $$v
      },
      expression: "MisrouteType1"
    }
  })], 1)], 1), _vm._v(" "), (_vm.currentFiltersTab != 'moreFilters') ? _c('div', {
    staticClass: "col-md-2 tabs-btn-css"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.searchByFilters(), _vm.searchByDateFilter()
      }
    }
  }, [_vm._v(" Search ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger ml-2",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4 mt-3"
  }, [_c('label', [_vm._v("Misroute Reason :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisrouteReasonList,
      "selected-option": _vm.MisrouteReasonObj,
      "name": "MisrouteReason1",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteReason
    },
    model: {
      value: (_vm.MisrouteReason1),
      callback: function($$v) {
        _vm.MisrouteReason1 = $$v
      },
      expression: "MisrouteReason1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 tabs-btn-css1"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.searchByFilters(), _vm.searchByDateFilter()
      }
    }
  }, [_vm._v(" Search ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger ml-2",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 ml-2 mt-3"
  }, [_c('span', {
    staticClass: "totalCount-Css"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))])]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12 tableTemplateCSS"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.PendingColumns,
      "IsWithDraw": true,
      "Shipmentloader": _vm.Shipmentloader,
      "showShipmentsList": _vm.showShipmentReqList
    },
    on: {
      "showMultiShipPopup": _vm.showMoreShipmentsList,
      "withDrawReq": _vm.withDrawReq
    },
    model: {
      value: (_vm.PendingReqModel),
      callback: function($$v) {
        _vm.PendingReqModel = $$v
      },
      expression: "PendingReqModel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_c('paginate', {
    ref: "PendingReqpaginate",
    attrs: {
      "page-count": _vm.PendingPagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])])], 1), _vm._v(" "), _c('b-tab', {
    class: {
      active: _vm.currentTab1 == 'Accepted'
    },
    attrs: {
      "title": _vm.tabTitle('Accepted', _vm.acceptedShipCount),
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.SwitchReqTabs()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "makermoreFilterCSS"
  }, [(_vm.currentFiltersTab != 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'moreFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('moreFilters')
      }
    }
  }, [_vm._v("More Filters\n                              ")])]) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'clearFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('clearFilters')
      }
    }
  }, [_vm._v("Clear Filters\n                              ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4 mt-1"
  }, [_c('label', [_vm._v("Enter ShippingIDs:")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchShip2),
      expression: "SearchShip2"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('SearchShip2')
    },
    attrs: {
      "id": "SearchShip2",
      "type": "text",
      "name": "SearchShip2",
      "placeholder": "Enter ShippingIDs"
    },
    domProps: {
      "value": (_vm.SearchShip2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.SearchShip2 = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-1"
  }, [_c('label', [_vm._v("Shipment Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ShipmentTypeList,
      "selected-option": _vm.ShipmentTypeObj,
      "name": "ShipmentType2",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectShipmentType
    },
    model: {
      value: (_vm.ShipmentType2),
      callback: function($$v) {
        _vm.ShipmentType2 = $$v
      },
      expression: "ShipmentType2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-1"
  }, [_c('label', [_vm._v("Misroute Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisroutetypeList,
      "selected-option": _vm.MisroutetypeObj,
      "name": "MisrouteType2",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteType
    },
    model: {
      value: (_vm.MisrouteType2),
      callback: function($$v) {
        _vm.MisrouteType2 = $$v
      },
      expression: "MisrouteType2"
    }
  })], 1)], 1), _vm._v(" "), (_vm.currentFiltersTab != 'moreFilters') ? _c('div', {
    staticClass: "col-md-2 tabs-btn-css"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.searchByFilters(), _vm.searchByDateFilter()
      }
    }
  }, [_vm._v(" Search ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger ml-2",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4 mt-3"
  }, [_c('label', [_vm._v("Misroute Reason :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisrouteReasonList,
      "selected-option": _vm.MisrouteReasonObj,
      "name": "MisrouteReason2",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteReason
    },
    model: {
      value: (_vm.MisrouteReason2),
      callback: function($$v) {
        _vm.MisrouteReason2 = $$v
      },
      expression: "MisrouteReason2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 tabs-btn-css1"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.searchByFilters(), _vm.searchByDateFilter()
      }
    }
  }, [_vm._v(" Search ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger ml-2",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 ml-2 mt-3"
  }, [_c('span', {
    staticClass: "totalCount-Css"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))])]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12 tableTemplateCSS"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.AcceptedColumns,
      "IsWithDraw": false,
      "Shipmentloader": _vm.Shipmentloader,
      "showShipmentsList": _vm.showShipmentReqList
    },
    on: {
      "showMultiShipPopup": _vm.showMoreShipmentsList
    },
    model: {
      value: (_vm.AcceptedReqModel),
      callback: function($$v) {
        _vm.AcceptedReqModel = $$v
      },
      expression: "AcceptedReqModel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_c('paginate', {
    ref: "AccReqpaginate",
    attrs: {
      "page-count": _vm.AcceptedPagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])])], 1), _vm._v(" "), _c('b-tab', {
    class: {
      active: _vm.currentTab1 == 'Rejected'
    },
    attrs: {
      "title": _vm.tabTitle('Rejected', _vm.rejectedShipCount),
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.SwitchReqTabs()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "Rejected-tabs mb-2"
  }, [_c('a', {
    staticClass: "rejectedBy-btn",
    class: {
      'active': _vm.currentRejScreenTab == 'RejByMDM'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetCurrentRejectedTab('RejByMDM')
      }
    }
  }, [_vm._v("Rejected By MDM " + _vm._s("(" + _vm.rejectedByMdMCount + ")"))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticClass: "rejectedBy-btn",
    class: {
      'active': _vm.currentRejScreenTab == 'RejBySVC'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetCurrentRejectedTab('RejBySVC')
      }
    }
  }, [_vm._v("Rejected By SVC " + _vm._s("(" + _vm.rejectedBySVCCount + ")"))])])]), _vm._v(" "), _c('div', {
    staticClass: "RejmoreFilterCSS"
  }, [(_vm.currentFiltersTab != 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'moreFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('moreFilters')
      }
    }
  }, [_vm._v("More Filters\n                              ")])]) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('span', [_c('a', {
    staticClass: "filter-btn",
    class: {
      'active': _vm.currentFiltersTab == 'clearFilters'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCurrentFilterTabs('clearFilters')
      }
    }
  }, [_vm._v("Clear Filters\n                              ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4 mt-1"
  }, [_c('label', [_vm._v("Enter ShippingIDs:")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchShip3),
      expression: "SearchShip3"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('SearchShip3')
    },
    attrs: {
      "id": "SearchShip3",
      "type": "text",
      "name": "SearchShip3",
      "placeholder": "Enter ShippingIDs"
    },
    domProps: {
      "value": (_vm.SearchShip3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.SearchShip3 = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-1"
  }, [_c('label', [_vm._v("Shipment Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.ShipmentTypeList,
      "selected-option": _vm.ShipmentTypeObj,
      "name": "ShipmentType3",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectShipmentType
    },
    model: {
      value: (_vm.ShipmentType3),
      callback: function($$v) {
        _vm.ShipmentType3 = $$v
      },
      expression: "ShipmentType3"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-1"
  }, [_c('label', [_vm._v("Misroute Type :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisroutetypeList,
      "selected-option": _vm.MisroutetypeObj,
      "name": "MisrouteType3",
      "placeholder": "Select Type"
    },
    on: {
      "select": _vm.selectMisrouteType
    },
    model: {
      value: (_vm.MisrouteType3),
      callback: function($$v) {
        _vm.MisrouteType3 = $$v
      },
      expression: "MisrouteType3"
    }
  })], 1)], 1), _vm._v(" "), (_vm.currentFiltersTab != 'moreFilters') ? _c('div', {
    staticClass: "col-md-2 tabs-btn-css"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.searchByFilters(), _vm.searchByDateFilter()
      }
    }
  }, [_vm._v(" Search ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger ml-2",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentFiltersTab == 'moreFilters') ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4 mt-3"
  }, [_c('label', [_vm._v("Misroute Reason :")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.MisrouteReasonList,
      "selected-option": _vm.MisrouteReasonObj,
      "name": "MisrouteReason3",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.selectMisrouteReason
    },
    model: {
      value: (_vm.MisrouteReason3),
      callback: function($$v) {
        _vm.MisrouteReason3 = $$v
      },
      expression: "MisrouteReason3"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 tabs-btn-css1"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.searchByFilters(), _vm.searchByDateFilter()
      }
    }
  }, [_vm._v(" Search ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger ml-2",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 ml-2 mt-3"
  }, [_c('span', {
    staticClass: "totalCount-Css"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))])]), _vm._v(" "), (_vm.currentRejScreenTab == 'RejByMDM') ? _c('div', {
    staticClass: "row col-md-12 tableTemplateCSS"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.RejectedColumns,
      "IsWithDraw": false,
      "Shipmentloader": _vm.Shipmentloader,
      "showShipmentsList": _vm.showShipmentReqList
    },
    on: {
      "showMultiShipPopup": _vm.showMoreShipmentsList
    },
    model: {
      value: (_vm.RejectedReqModel),
      callback: function($$v) {
        _vm.RejectedReqModel = $$v
      },
      expression: "RejectedReqModel"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentRejScreenTab != 'RejByMDM') ? _c('div', {
    staticClass: "row col-md-12 tableTemplateCSS"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.RejectedColumns,
      "IsWithDraw": false,
      "IsRaiseBtnAction": true,
      "Shipmentloader": _vm.Shipmentloader,
      "showShipmentsList": _vm.showShipmentReqList
    },
    on: {
      "showMultiShipPopup": _vm.showMoreShipmentsList,
      "RaiseReqAction": _vm.raiseRejRequestToSVCorCLT
    },
    model: {
      value: (_vm.RejectedReqModel),
      callback: function($$v) {
        _vm.RejectedReqModel = $$v
      },
      expression: "RejectedReqModel"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_c('paginate', {
    ref: "RejReqpaginate",
    attrs: {
      "page-count": _vm.RejectedPagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])])], 1)], 1)], 1)], 1)], 1)])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "title": "Take Bulk Action",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.MoreShipmentModel),
      callback: function($$v) {
        _vm.MoreShipmentModel = $$v
      },
      expression: "MoreShipmentModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [(_vm.ActiveTabIndex == 0) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Same Vendor Shipments List")]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Same Request Shipments List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.CloseMoreShipmentModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "padding": "2pt"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.MultiShipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.MultiShipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('load-table-template', {
    attrs: {
      "columns": _vm.moreShipmentsColumns,
      "showShipmentsList": _vm.sameVendorShipList
    },
    model: {
      value: (_vm.moreShipLink),
      callback: function($$v) {
        _vm.moreShipLink = $$v
      },
      expression: "moreShipLink"
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "4pt"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.CloseMoreShipmentModel
    }
  }, [_vm._v("Close")])])], 1)])])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32d4352a","hasScoped":false}!./src/views/components/MisrouteRequestMaker/MisrouteRequestMaker.component.html
// module id = 1457
// module chunks = 1